import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PinkButton from "../component/PinkButton";
import { SelectInput } from "../component/Inputs";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useQuery } from "../hooks/useQuery";
import { getCampaignTypes, getCampaignAssets } from "../hooks/apiCalls";

const Browse = () => {
  let query = useQuery();
  const { campaign_id } = useParams();
  const [hasAuth, setUserAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [types, setTypes] = useState([]);
  const [queryObj, setQueryObj] = useState({
    type: "",
    theme: "light",
  });
  const [browsingData, setBrowsingData] = useState([]);
  const [imageTitle, setImageTitle] = useState();

  useEffect(() => {
    if (query.get("userAuth") && campaign_id) {
      handleGetCampaignTypes();
    }
  }, []);

  useEffect(() => {
    if (!isLoading) {
      console.log(queryObj);
      setIsLoading(true);
      handleGetCampaignAssets();
    }
  }, [queryObj]);

  const handleGetCampaignTypes = async () => {
    let bearer = query.get("userAuth");
    const { data } = await getCampaignTypes(bearer, campaign_id);

    setTypes(data.data);
  };

  const objToParams = (params) => {
    let arr = Object.keys(params).map((key, i) => {
      return `${key}=${params[key]}`;
    });

    return arr.join("&");
  };

  const handleGetCampaignAssets = async () => {
    let bearer = query.get("userAuth");
    const {
      data: { data: resData },
    } = await getCampaignAssets(bearer, campaign_id, objToParams(queryObj));

    if (resData.length !== 0) {
      let arr = [];
      Object.keys(resData[0]).forEach((e) => {
        let keys = ["front_url", "back_url", "left_url", "right_url"];

        if (keys.includes(e)) {
          arr.push({
            title: e.replace("_url", ""),
            imgSrc: resData[0][e],
          });
        }
      });

      setBrowsingData(arr);
      setImageTitle(arr[0].title);
    } else {
      setBrowsingData([]);
    }

    setIsLoading(false);
  };
  const onItemChange = (index) => {
    const selectedView = browsingData[index];
    setImageTitle(selectedView.title);
  };
  return (
    <div className="min-h-screen flex flex-col py-4">
      {isLoading && (
        <div className="w-full absolute top-0 left-0 bg-gray-900/75 min-h-screen z-10 flex">
          <div className="flex-1 flex items-center justify-center">
            <p className="text-carching-pink text-3xl">Loading...</p>
          </div>
        </div>
      )}
      <div className="w-full flex p-2">
        <div className="flex items-center px-2">
          {imageTitle && (
            <p className="text-carching-pink">{imageTitle + " view"}</p>
          )}
        </div>
        <div className="flex items-center flex-1">
          <SelectInput
            className="flex-1 text-carching-pink"
            title="car type"
            name="type"
            onChange={(e) => setQueryObj({ ...queryObj, type: e.target.value })}
            value={queryObj.type}
          >
            {types.map((type) => (
              <option className="text-carching-pink" value={type}>
                {type}
              </option>
            ))}
          </SelectInput>

          <div className="flex justify-end">
            <div className="flex flex-col items-center px-2">
              <input
                type="radio"
                id="dark"
                name="theme"
                value="dark"
                checked={queryObj.theme === "dark"}
                onChange={(e) =>
                  setQueryObj({ ...queryObj, theme: e.target.value })
                }
              />
              <label for="dark" className="text-carching-pink">
                dark
              </label>
            </div>
            <div className="flex flex-col items-center px-2">
              <input
                type="radio"
                id="light"
                name="theme"
                value="light"
                checked={queryObj.theme === "light"}
                onChange={(e) =>
                  setQueryObj({ ...queryObj, theme: e.target.value })
                }
              />
              <label for="light" className="text-carching-pink">
                light
              </label>
            </div>
          </div>
        </div>
      </div>
      {browsingData.length > 0 ? (
        <div className="w-full flex-1">
          <Carousel
            centerMode={true}
            onClickItem={(e) => console.log(e)}
            onChange={onItemChange}
            showThumbs={false}
            centerSlidePercentage={100}
            dynamicHeight={true}
            emulateTouch={true}
            infiniteLoop={true}
            showStatus={false}
          >
            {browsingData.map((img) => (
              <div className="p-2">
                <img src={img.imgSrc} />
              </div>
            ))}
          </Carousel>
        </div>
      ) : (
        <div className="w-full flex-1 flex items-center justify-center">
          <p className="text-carching-pink text-xl">
            no preview for current selection
          </p>
        </div>
      )}
      {/* <div className="page-bottom w-full max-w-lg px-2">
                <PinkButton
                    text="Ok"
                />
            </div> */}
    </div>
  );
};

export default Browse;
